import { DESCRIPTION_COPY_LIMITS, TITLE_COPY_LIMITS } from "../copy-policy";
/** Fallback destination when no collection metadata is available. */
export const FEATURED_PRESS_CTA_HREF = "/news";
/**
 * The sizes this panel's title may be set at, and the one it defaults to.
 *
 * Read twice from this one declaration: by the slot below, and by the renderer
 * in `@diality/ui`, so the menu cannot offer a step the renderer has no size for.
 *
 * DEFAULTS TO L (80px) THOUGH THE PANEL SHIPPED AT 64. Design asked for the
 * larger opening knowing it differs from the prototype, so adopting this field
 * makes every published panel's title grow one step. 64 remains reachable as M.
 * This is the one adoption where the default is not the block's existing size —
 * PersonGrid's L was already what it drew.
 */
export const FEATURED_PRESS_TITLE_SCALE = {
    default: "l",
    steps: ["xl", "l", "m"],
    sizes: "title",
};
export const featuredPressSchema = {
    componentId: "FeaturedPress",
    scalarSlots: [
        {
            key: "collectionId",
            label: "Collection",
            type: "select",
            optionsSource: "collections",
        },
        {
            key: "leadArticleId",
            label: "Lead article (picture required)",
            type: "select",
            optionsSource: "collection-entries-with-image",
            dependsOn: "collectionId",
        },
        { key: "title", ...TITLE_COPY_LIMITS, label: "Title", type: "text" },
        // `<the key it sizes>Size` — the convention PersonGrid's `headingSize` set,
        // read against the field it belongs to rather than fixed across blocks, so
        // `title` and `titleSize` read as a pair in stored scalars.
        {
            key: "titleSize",
            label: "Title size",
            type: "type-scale",
            scale: FEATURED_PRESS_TITLE_SCALE,
        },
        {
            key: "description",
            ...DESCRIPTION_COPY_LIMITS,
            label: "Description",
            type: "textarea",
        },
        // "CTA label" rather than "Call-to-action label", matching `promoSchema` —
        // the closest sibling with the same field. The refusal message in
        // `../featured-press` says "call-to-action label" in full, which is the house
        // phrase `validatePromo` and `validateHeroMediaCentered` already produce.
        // The two wordings differ, and they differ in Promo too; this block inherits
        // that rather than inventing a third convention for one field.
        { key: "ctaLabel", label: "CTA label", type: "text" },
    ],
    mediaSlots: [],
    repeatSlots: [
        {
            key: "articles",
            label: "Additional articles (exactly two)",
            itemLabel: "Article",
            minItems: 2,
            maxItems: 2,
            scalarSlots: [
                {
                    key: "articleId",
                    label: "Article",
                    type: "select",
                    optionsSource: "collection-entries",
                    dependsOn: "collectionId",
                },
            ],
            mediaSlots: [],
        },
    ],
};
//# sourceMappingURL=featured-press.js.map